const bool2str = b => b ? 'true' : 'false';

const setAttributes = (el, attr) =>
    Object.keys(attr).forEach(k => {
        const v = attr[k];
        if (v === null)
            el.removeAttribute(k);
        else
            el.setAttribute(k, v);
    });

const KeyCode = {
    CANCEL: 3,
    HELP: 6,
    BACK_SPACE: 8,
    TAB: 9,
    CLEAR: 12,
    RETURN: 13,
    ENTER: 14,
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINTSCREEN: 44,
    INSERT: 45,
    DELETE: 46,
};

const componentId = () => Math.random().toString(32).slice(2, 12);

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

const forAll = (selector, fn) => Array.prototype.forEach.call(document.querySelectorAll(selector), fn);

/**
 * Helper function for appending child nodes
 * @param {HTMLElement} parentNode
 * @param {Node} child
 * @returns {void|*|ActiveX.IXMLDOMNode}
 */
const appendChild = (parentNode, child) => parentNode.appendChild(child);

/**
 * Migrates all child nodes within a parent node to a new parent
 * @param {HTMLElement} currentParent Parent node to take children from
 * @param {HTMLElement} newParent
 * @param {function(HTMLElement, Node): void} onInsert Option to overwrite how elements are inserted, so you could provide a function inserting before or after a pivot
 */
export const migrateChildNodes = (currentParent, newParent, onInsert = appendChild) => {
    while (currentParent.childNodes.length > 0) {
        onInsert(newParent, currentParent.childNodes[0]);
    }
};

export {
    bool2str,
    componentId,
    debounce,
    forAll,
    setAttributes,
    KeyCode,
};
